export enum ReferrerKindEnum {
  DOULA = 'DOULA',
  OBSTETRICIAN = 'OBSTETRICIAN',
  NURSE = 'NURSE',
  MATERNITY = 'MATERNITY',
  OTHER = 'OTHER',
}

export const REFERRER_KIND_VALUES: ReferrerKindEnum[] = [
  ReferrerKindEnum.DOULA,
  ReferrerKindEnum.OBSTETRICIAN,
  ReferrerKindEnum.NURSE,
  ReferrerKindEnum.MATERNITY,
  ReferrerKindEnum.OTHER,
];

export const DEFAULT_REFERRER_KIND = ReferrerKindEnum.OTHER;

export function toReferrerKind(
  value: string | null | undefined,
): ReferrerKindEnum {
  return REFERRER_KIND_VALUES.includes(value as ReferrerKindEnum)
    ? (value as ReferrerKindEnum)
    : DEFAULT_REFERRER_KIND;
}
